import { render, staticRenderFns } from "./DeadLetterQueues.vue?vue&type=template&id=4eea2eda&scoped=true&"
import script from "./DeadLetterQueues.vue?vue&type=script&lang=js&"
export * from "./DeadLetterQueues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eea2eda",
  null
  
)

export default component.exports